import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';
import EmptyItemsSVG from '../empty-items.svg';
import { emptyRowMessage } from '../items-table/empty-row/messages';
import style from './style.module.less';

const EditItemsTableEmptyRow = ({ isReturn = false }) => (
  <FlexColumn className={style['empty-row-container']}>
    <img alt='' className={style['empty-row-image']} src={EmptyItemsSVG} />
    <div className={style['empty-row-message']}>
      <FormattedMessage {...emptyRowMessage} values={{ isReturn }} />
    </div>
  </FlexColumn>
);

export { EditItemsTableEmptyRow };

EditItemsTableEmptyRow.propTypes = {
  isReturn: PropTypes.bool,
};
